$(document).ready(function () {
  var mainMenuAddMargin = function () {
    if (location.pathname.split('@')[0] != '/') {
      var body = $('body');
      $('.main-menu').css('margin-top', body.css('margin-top'));
    }
  }

  if ($('body').hasClass('neos-backend')) {
    if (typeof document.addEventListener === 'function') {
      document.addEventListener('Neos.PageLoaded', function () {
        if (location.pathname.split('@')[0] == '/') {
          $('body').removeClass('page').addClass('homepage');
        } else {
          $('body').removeClass('homepage').addClass('page');
          mainMenuAddMargin();
        }
      }, false);
    }

    $('body').on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', function() {
      mainMenuAddMargin();
    });
  }
});
